import { render, staticRenderFns } from "./LogoutRefactored.vue?vue&type=template&id=41399d0a"
import script from "./LogoutRefactored.vue?vue&type=script&lang=js"
export * from "./LogoutRefactored.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports